import React from "react";
import { Loader2, AlertCircle } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
function ToursList() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="columns-1 md:columns-3 gap-8 space-y-8 md:space-y-0">
        {[...Array(6)].map((_, i) => <div key={i} className="break-inside-avoid mb-8" data-index={i}>
            <div className="h-96 w-full rounded-2xl bg-muted/20 animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <AlertCircle className="h-10 w-10 text-destructive mb-4" />
        <p className="text-muted-foreground mb-4">Failed to load tours.</p>
        <Button variant="outline" onClick={refetch}>
          Try Again
        </Button>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No tours found.</p>
      </div>;
  }
  return <div className="columns-1 md:columns-3 gap-8 space-y-8 md:space-y-0">
      {posts.map((post, i) => <div key={post.id} className="break-inside-avoid mb-8" data-index={i}>
          <Card className="group h-full rounded-2xl p-4 bg-card border-transparent shadow-none hover:shadow-md transition-all duration-300">
            {}
            <div className="relative overflow-hidden rounded-lg bg-muted w-full mb-6">
              <Link to={post.link || "#"}>
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105 block" /> : <div className="w-full aspect-[4/3] bg-muted flex items-center justify-center text-muted-foreground">
                    No Image
                  </div>}
              </Link>
            </div>

            {}
            <div className="flex flex-col items-start gap-3">
              <h3 className="text-xl font-bold text-primary leading-tight">
                {post.title}
              </h3>
              
              <div className="text-muted-foreground text-sm font-sans line-clamp-3" dangerouslySetInnerHTML={{
            __html: post.excerpt || ""
          }} />
            </div>
          </Card>
        </div>)}
    </div>;
}
export default function ToursMasonryGrid() {
  const wp_query = new WP_Query({
    post_type: "tour",
    per_page: 9,
    orderby: "date",
    order: "DESC"
  });
  return <section id="tours-masonry-grid" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-[1280px]">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Our Exclusive Tours
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Discover unique experiences curated just for you.
          </p>
        </div>

        <PostsProvider wp_query={wp_query}>
          <ToursList />
        </PostsProvider>
      </div>
    </section>;
}